import React, { FC }                 from 'react';
import { Label }                     from 'semantic-ui-react';
import { StyledContainer }           from '../../containers';
import { Position, SemanticUIColor } from '../../../types/componentPropTypes';

//@ts-ignore
let environment = __ENV__;

interface EnvironmentBugProps {
	isVisible?: boolean
}

const defaultProps = {
	inVisible: true
}

export const EnvironmentVisualFlag: FC<EnvironmentBugProps> = ( defaultProps ) => {
	
	let label: string,
	    color: SemanticUIColor;
	
	if( environment.isDevelopment ){
		label = 'DEV';
		color = SemanticUIColor.RED;
	}
	if( environment.isTesting ){
		label = 'TEST';
		color = SemanticUIColor.ORANGE;
	}
	if( environment.isStaging ){
		label = 'STAGE';
		color = SemanticUIColor.TEAL;
	}
	if( environment.isProduction ){
		return null;
	}
	
	return (
		
		<Label circular
		       color={ color }
		       size={ 'large' }
		       corner={ 'left' }
		       className={ 'position--fixed position--top position--left z-index--5000 cursor--default' }>
			<StyledContainer position={ Position.ABSOLUTE } style={ { top: 3, left: 5 } } className={ 'text-left text--xs' }>{ label }</StyledContainer>
		</Label>
	);
};
